import React from 'react';
import styled from 'styled-components';

import { toCSS } from '../../../../helpers/styles';
import useResourceUrl from '../../../../hooks/useResourceUrl';

export interface ITrackCoverageProps {
  radius: string;
  x: string;
  y: string;
  strokeWidth: string;
  color: string;
  innerAreaHeight: string;
  innerAreaWidth: string;
  innerImage: {
    filename: string;
    value: string;
    filezie: number;
  };
}

const Svg = styled.svg`
  width: 100%;
  height: 100%;
`;
const TrackCoverageContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`;

const InnerImage = styled.img<any>`
  ${({ innerAreaHeight, innerAreaWidth, x, y }) => `
        width: ${toCSS(innerAreaWidth)};
        height: ${toCSS(innerAreaHeight)};
        position: absolute;
        left: ${toCSS(+x - +innerAreaWidth / 2)};
        top: ${toCSS(+y - +innerAreaHeight / 2)};
    `}
`;

export function TrackCoverage(props: ITrackCoverageProps) {
  const {
    x,
    y,
    radius,
    strokeWidth,
    color,
    innerAreaHeight,
    innerAreaWidth,
    innerImage,
  } = props;
  const imgSrc = useResourceUrl(innerImage.value, innerImage.filename);
  return (
    <TrackCoverageContainer>
      <Svg>
        <circle
          cx={x}
          cy={y}
          r={`${radius}px`}
          stroke={color}
          strokeWidth={strokeWidth}
          fillOpacity="0"
        />
      </Svg>
      <InnerImage
        innerAreaHeight={innerAreaHeight}
        innerAreaWidth={innerAreaWidth}
        x={x}
        y={y}
        src={imgSrc}
      />
    </TrackCoverageContainer>
  );
}
